import { Injectable } from '@angular/core';
import { AbstractService } from './abstract-service.service';

@Injectable({
    providedIn: 'root',
})
export class TimeOffService extends AbstractService {
    path = '/TimeOff';
}
